// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0130fbb7","453":"b7149057","455":"c9a41e93","977":"73d338eb"}[chunkId] + ".chunk.js";
};